<template>
  <div>
    <!-- <p class="c-inner-title">自动化营销设置</p> -->
    <div class="auto">
      <page-title title="自动化营销设置" icon="fa-wechat"></page-title>
    </div>
    <el-row class="box-row m-t-15">
      <el-col class="box-col" :span="24">
        <div class="table-wrap">
          <el-row class="table-control">
            <el-col :span="12">
              <el-button type="primary" @click="addHandle" class="el-icon-plus" size="small"> 添加任务</el-button>
            </el-col>
            <el-col :span="12" class="flex-box j-c-e">
              <el-select v-model="filter.send_type" placeholder="请选择类型" size="small" class="m-lr-5">
                <el-option
                  key=""
                  label="请选择类型"
                  value="">
                </el-option>
                <el-option
                  v-for="item in typeOptions"
                  :key="item.id"
                  :label="item.label"
                  :value="String(item.id)">
                </el-option>
              </el-select>
              <el-select v-model="filter.status" placeholder="请选择状态" size="small">
                <el-option
                  key=""
                  label="请选择状态"
                  value="">
                </el-option>
                <el-option
                  v-for="item in statusOptions"
                  :key="item.id"
                  :label="item.label"
                  :value="String(item.id)">
                </el-option>
              </el-select>
              <el-input placeholder="搜索名称" v-model.trim="filter.search" clearable class="m-lr-5" style="width:200px;" size="small"></el-input>
              <el-button type="primary" @click="handleChangeFilter" size="small">搜索</el-button>
            </el-col>
          </el-row>
          <el-table
            :data="tableData"
            style="width: 100%" v-loading="loading" size="small">
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="send_type_name" label="回复类型"></el-table-column>
            <el-table-column prop="status_name" label="状态"></el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>
            <el-table-column prop="last_time" label="最后执行时间"></el-table-column>
            <el-table-column prop="create_time" label="创建时间"></el-table-column>
            <el-table-column width="330" label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="editHandle(scope.row)"
                  type="primary"
                  size="small">
                  查看任务
                </el-button>
                <el-button
                  @click="getDataDetails(scope.row)"
                  size="small">
                  查看数据
                </el-button>
                <el-button
                  v-show="scope.row.status === 1"
                  @click="deleteHandle(scope.row.id, 0)"
                  size="small">
                  关闭
                </el-button>
                <el-button
                  v-show="scope.row.status === 0"
                  @click="deleteHandle(scope.row.id, 1)"
                  size="small">
                  开启
                </el-button>
                <el-button
                  @click="deleteHandle(scope.row.id, -1)"
                  size="small">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div v-if="total > filter.limit" class="main-page m-t-10 p-none">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="Number(filter.page)"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="Number(filter.limit)"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="colorBox" v-show="colorShow">
      <photoshop v-model="color" @cancel="cancelFn" @ok="okFn" style="margin:200px auto 0;"></photoshop>
    </div>
    <el-dialog title="添加任务" :modal-append-to-body="false" fullscreen :visible.sync="dialogVisible" width="1200px" class="phone-d" @close="handleExit">
      <el-form ref="formTable" :rules="rules" :model="form" label-width="140px" size="small" v-loading="dialogLoading">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="用户筛选" prop="filter" v-loading="queryLoading">
          <!-- <user-filters-custom :filters="filters" :chooseValDemo="chooseValStr" :count="count" @getValues="getValues" :noheader="true" :nobtn="true"></user-filters-custom> -->
          <track-user-filters :filters="filters" :options="filterOptions" :refresh="refreshIndex" @getValues="getValues"></track-user-filters>
        </el-form-item>
        <el-form-item label="回复类型" prop="send_type">
          <el-radio-group v-model="form.send_type">
            <el-radio label="template" v-if="$store.state.user && $store.state.user.service_type_info && String($store.state.user.service_type_info['id']) === '2'">模板消息</el-radio>
            <el-radio label="message">客服消息</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="" prop="">
          <a href="javascript:;" v-if="form.send_type === 'template'" @click="addModel">添加</a>
          <a href="javascript:;" v-else @click="addMaterial">添加</a>
        </el-form-item>
        <el-form-item label="" v-if="form.send_content.length > 0 && form.send_type === 'template'">
          <div class="modelbox" v-for="(item, index) in form.send_content" :key="index">
            <div class="modelcon">
              <p>{{item.template_name}}</p>
              <ul>
                <li v-if="item.data.first" :style="'color:' + item.data.first.color">{{item.data.first.value}}</li>
                <li v-for="(list, listIndex) in item.data" v-if="listIndex !== 'first' && listIndex !== 'remark'" :key="listIndex">{{list.title}}：<span :style="'color:' + list.color">{{list.value}}</span></li>
                <li v-if="item.data.remark" :style="'color:' + item.data.remark.color">{{item.data.remark.value}}</li>
              </ul>
            </div>
            <div class="modelcontrol">
              <a v-if="item.url !== ''" :href="item.url" target="_blank" class="fl">详情</a>
              <a v-if="item.miniprogram.appid !== ''" href="javascript:;" target="_blank" class="fl">跳转小程序</a>
              <a href="javascript:;" class="fr" @click="deleteModel(index)">删除</a>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="" v-if="form.send_content.length > 0 && form.send_type === 'message'">
          <div>
            <material-show v-model="form.send_content"></material-show>
          </div>
        </el-form-item>
        <el-form-item label="回流监控" prop="is_tk" v-if="showTk">
          <el-radio v-model="form.is_tk" label="1">是</el-radio>
          <el-radio v-model="form.is_tk" label="0">否</el-radio>
        </el-form-item>
        <el-form-item label="延迟时间" prop="delay">
          <el-input-number v-model="form.delay" controls-position="right" :min="10" :max="maxHour"></el-input-number><span class="font12">（单位：分钟。 设置用户触发以上行为后,延迟推送的时间）</span>
        </el-form-item>
        <el-form-item label="同一用户间隔时间" prop="interval_time">
          <el-input-number v-model="form.interval_time" controls-position="right" :min="10"></el-input-number><span class="font12">（单位：分钟。 同一用户多次触发本任务,间隔时间内只推送一次）</span>
        </el-form-item>
        <el-form-item label="任务开始时间" prop="begin_time">
          <el-date-picker v-model="form.begin_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"></el-date-picker><span class="font12">（代表该时间范围内会一直执行本任务,任务执行时会筛选  当前时间 - "延迟时间" 那一时刻发生行为的用户推送消息）</span>
        </el-form-item>
        <el-form-item label="任务结束时间" prop="end_time">
          <el-date-picker v-model="form.end_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSubmit">确定</el-button>
          <el-button @click="handleExit">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="添加模板" :modal-append-to-body="false" :visible.sync="modelVisible" width="800px" class="phone-d">
      <el-form ref="modelForm" :rules="modelrules" :model="modelfrom" label-width="120px" size="small" v-loading="modelLoading">
        <el-form-item label="消息模板" prop="template_id">
          <el-select v-model="modelfrom.template_id" placeholder="请选择">
            <el-option :label="item.title" v-for="(item, index) in temList" :key="index" :value="item.template_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form ref="contentTable" :rules="contentRules" :model="content" label-width="120px" size="small" v-if="content !== ''">
          <el-form-item :label="item.title" v-for="(item, index) in contentList" :key="index" :prop="item.key" style="position: relative;">
            <el-input v-model="content[item.key]" @change="inputChange(content[item.key], item.key)" style="width: 93%;"></el-input>
            <span class="colorSpan" @click.stop="showColorFn(item.key)" :style="'background:' + contentColor[item.key]"></span>
          </el-form-item>
        </el-form>
        <el-form-item label="跳转链接" prop="urlType">
          <el-radio-group v-model="modelfrom.urlType">
            <el-radio label="0">无</el-radio>
            <el-radio label="1">网页地址</el-radio>
            <el-radio label="2">小程序地址</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="网页地址" prop="url" v-if="Number(modelfrom.urlType) === 1">
          <el-input v-model="modelfrom.url"></el-input>
        </el-form-item>
        <el-form-item label="appid" prop="appid" v-if="Number(modelfrom.urlType) === 2">
          <el-input v-model="modelfrom.appid"></el-input>
        </el-form-item>
        <el-form-item label="pagepath" prop="pagepath" v-if="Number(modelfrom.urlType) === 2">
          <el-input v-model="modelfrom.pagepath"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="modelSubmit">确定</el-button>
          <el-button @click="modelExit">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="选择素材" :modal-append-to-body="false" :visible.sync="materialVisible" width="1000px" class="phone-d">
      <material-box v-model="form.send_content"></material-box>
    </el-dialog>
    <el-dialog title="查看任务" :modal-append-to-body="false" :visible.sync="editVisible" width="1200px" class="phone-d" @close="handleExit">
      <el-form ref="formTable" :rules="rules" :model="details" label-width="140px" size="small" v-loading="dialogLoading">
        <el-form-item label="名称" prop="name">
          <el-input v-model="details.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="用户筛选">
          <div v-for="(item, index) in details.filter" :key="index" class="edit-filter-box">
            <div class="gx auto" v-if="index > 0">或</div>
            <ul v-for="(item2, index2) in item" :key="index2">
              <li><b>{{index2}}</b></li>
              <li v-for="(item3, index3) in item2" :key="index3">
                <p>
                  {{index3 + ' : '}}
                  <span v-for="(item4, index4) in item3" :key="index4">{{item4}}</span>
                </p>
              </li>
            </ul>
          </div>
        </el-form-item>
        <el-form-item label="回复类型" prop="send_type">
          <el-radio-group v-model="details.send_type" disabled>
            <el-radio label="template">模板消息</el-radio>
            <el-radio label="message">客服消息</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="" v-if="details.send_type === 'template'">
          <div class="modelbox" v-for="(item, index) in details.send_content" :key="index">
            <div class="modelcon">
              <p>{{item.template_name}}</p>
              <ul>
                <li v-if="item.data.first" :style="'color:' + item.data.first.color">{{item.data.first.value}}</li>
                <li v-for="(list, listIndex) in item.data" v-if="listIndex !== 'first' && listIndex !== 'remark'" :key="listIndex">{{list.title}}：<span :style="'color:' + list.color">{{list.value}}</span></li>
                <li v-if="item.data.remark" :style="'color:' + item.data.remark.color">{{item.data.remark.value}}</li>
              </ul>
            </div>
            <div class="modelcontrol">
              <a v-if="item.url !== ''" :href="item.url" target="_blank" class="fl">详情</a>
              <a v-if="item.miniprogram.appid !== ''" href="javascript:;" target="_blank" class="fl">跳转小程序</a>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="" v-if="details.send_type === 'message'">
          <div>
            <material-show v-model="details.send_content" :disabled="true"></material-show>
          </div>
        </el-form-item>
        <el-form-item label="回流监控" prop="is_tk" v-show="showTk">
          <el-radio v-model="details.is_tk" label="1" disabled>是</el-radio>
          <el-radio v-model="details.is_tk" label="0" disabled>否</el-radio>
        </el-form-item>
        <el-form-item label="延迟时间" prop="delay">
          <el-input-number v-model="details.delay" controls-position="right" disabled :min="5" :max="maxHour"></el-input-number><span class="font12">（单位：分钟。 设置用户触发以上行为后,延迟推送的时间）</span>
        </el-form-item>
        <el-form-item label="同一用户间隔时间" prop="interval_time">
          <el-input-number v-model="details.interval_time" controls-position="right" disabled :min="1"></el-input-number><span class="font12">（单位：分钟。 同一用户多次触发本任务,间隔时间内只推送一次）</span>
        </el-form-item>
        <el-form-item label="任务开始时间" prop="begin_time" v-show="details.begin_time">
          <el-date-picker v-model="details.begin_time" type="datetime" disabled value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="任务结束时间" prop="end_time" v-show="details.end_time">
          <el-date-picker v-model="details.end_time" type="datetime" disabled value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="备注" prop="remark" v-show="details.remark">
          <el-input v-model="details.remark" disabled></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="details.status" disabled>
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button @click="handleExit">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <detail-dialog :title="row.name" :status="dialogStatus" :dialogVisible="dialogVisible2" :chartData="dialogChart" :tableHead="dialogTableHead" :tableData="dialogTableData" @tableSortChange="tableSortChange" @visibleFn="visibleFn">
      <div slot="bar" style="text-align: right; padding: 15px 0;">
        <dates-picker v-model="dialogDate" size="mini" style="margin-right:15px;position: relative; top: 2px;"></dates-picker>
        <el-radio-group v-model="dialogInterval" size="mini">
          <el-radio-button :label="item.value" v-for="(item, index) in dialogOptions" :key="index">{{item.label}}</el-radio-button>
        </el-radio-group>
      </div>
    </detail-dialog>
  </div>
</template>

<script>
import { Mp } from '@/model'
import { Photoshop } from 'vue-color'
import { Data as DataController } from '@/controller'
export default {
  data () {
    return {
      color: '#194d33',
      colorShow: false,
      colorKey: '',
      loading: true,
      search: '',
      temList: [],
      typeOptions: [
        {
          id: 'template',
          label: '模板消息'
        },
        {
          id: 'message',
          label: '客服消息'
        }
      ],
      statusOptions: [
        {
          id: 1,
          label: '开启'
        },
        {
          id: 0,
          label: '关闭'
        }
      ],
      tableData: [],
      totalData: [],
      filter: {
        send_type: '',
        status: '',
        search: '',
        page: '1',
        limit: '20'
      },
      total: 0,
      dialogVisible: false,
      dialogLoading: false,
      details: {},
      form: {
        id: '',
        name: '',
        send_type: 'template',
        delay: 10,
        interval_time: 10,
        filter: {},
        send_content: [],
        begin_time: '',
        end_time: '',
        status: 1,
        remark: '',
        is_tk: '1'
      },
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        send_type: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ],
        delay: [
          { required: true, message: '请填写延迟时间', trigger: 'blur' }
        ],
        interval_time: [
          { required: true, message: '请填写间隔时间', trigger: 'blur' }
        ],
        filter: [
          { required: true, message: '请筛选用户', trigger: 'blur' }
        ],
        send_content: [
          { required: true, message: '请填写回复内容', trigger: 'blur' }
        ]
      },
      modelVisible: false,
      contentList: {},
      content: {},
      contentColor: {},
      contentRules: {},
      modelLoading: false,
      modelfrom: {
        urlType: '0',
        template_id: '',
        content: {},
        url: '',
        appid: '',
        pagepath: ''
      },
      modelrules: {
        template_id: [
          { required: true, message: '请选择模板！', trigger: 'change' }
        ],
        url: [
          { required: false, message: '请填写地址', trigger: 'blur' }
        ],
        appid: [
          { required: false, message: '请填写appid', trigger: 'blur' }
        ],
        pagepath: [
          { required: false, message: '请填写pagepath', trigger: 'blur' }
        ]
      },
      materialVisible: false,
      refreshIndex: 0,
      filters: {},
      filterOptions: [],
      queryLoading: false,
      editVisible: false,
      maxHour: 720 * 10000,
      showTk: false,
      dialogDate: this.util.getDataPickerDefault(),
      dialogVisible2: false,
      dialogStatus: true,
      dialogChart: {},
      dialogInterval: 'day',
      row: '',
      dialogOptions: [
        {
          value: 'day',
          label: '日'
        },
        {
          value: 'week',
          label: '周'
        },
        {
          value: 'month',
          label: '月'
        }
      ],
      dialogTableHead: [
        {
          title: '日期',
          tag: 'name',
          sort: true
        },
        {
          title: '成功人数',
          tag: 'success',
          sort: true,
          thousand: true
        },
        {
          title: '失败人数',
          tag: 'fail',
          sort: true,
          thousand: true
        }
      ],
      dialogTableData: []
    }
  },
  watch: {
    'modelfrom.template_id': function (val) {
      if (val !== '') {
        this.getTemplateFields(val)
      }
    },
    '$route': function () {
      this.queryToFilter()
    },
    'form.send_type': function (val) {
      this.form.send_content = []
      if (val === 'template') {
        this.maxHour = 720 * 10000
      } else {
        this.maxHour = 48 * 60 - 80
      }
      this.form.delay = 10
    },
    'dialogInterval': function (val, oldval) {
      if (this.dialogVisible2) {
        this.getDataDetails(this.row)
      }
    },
    'dialogDate': function (val, oldval) {
      if (this.dialogVisible2) {
        this.getDataDetails(this.row)
      }
    },
    'form.send_content': function (val) {
      var showTk = false
      if (this.form.send_type === 'message') {
        this.form.send_content.map(item => {
          if (item['type'] === 'local_text' || item['type'] === 'news') {
            showTk = true
          }
        })
      } else {
        this.form.send_content.map(item => {
          if (item.url !== '') {
            showTk = true
          }
        })
      }
      this.showTk = showTk
    }
  },
  components: {
    Photoshop
  },
  methods: {
    async getDataDetails (row) {
      this.row = row
      this.dialogVisible2 = true
      this.dialogStatus = !this.dialogStatus
      let res = await Mp.Custom.getTaskPushLog({
        task_id: row.id,
        interval: this.dialogInterval,
        begin_time: this.dialogDate[0],
        end_time: this.dialogDate[1]
      })
      this.dialogChart = DataController.Mp.trackBarAndLine(res['data'] || '')
      this.dialogTableData = res['data'] || []
    },
    visibleFn (val) {
      this.dialogVisible2 = val
      this.dialogStatus = true
      this.dialogDate = this.util.getDataPickerDefault()
      this.dialogInterval = 'day'
      // this.isMessageOrEvent = false
    },
    tableSortChange (column) {
      var tableData = this.dialogTableData
      this.util.arraySort(tableData, column['prop'], column['order'])
      this.dialogTableData = tableData
    },
    inputChange (val, keyname) {
      // console.log(val, keyname)
      this.content[keyname] = val
      this.content = Object.assign({}, this.content)
    },
    handleChangeFilter (val) {
      this.filter['page'] = 1
      this.filterHandle()
    },
    resetFilter () {
      this.filter = {
        send_type: '',
        status: '',
        search: '',
        page: '1',
        limit: '20'
      }
      this.filterHandle()
    },
    filterHandle () {
      this.$router.replace({path: '/mp/custom/track_reply', query: this.filter})
    },
    queryToFilter () {
      let filter = JSON.parse(JSON.stringify(this.$route.query))
      for (let k in this.filter) {
        if (!filter[k]) {
          filter[k] = this.filter[k]
        }
      }
      this.filter = filter
      this.getTaskList()
    },
    handleSizeChange (val) {
      this.filter['page'] = 1
      this.filter['limit'] = val
      this.filterHandle()
    },
    handleCurrentChange (val) {
      this.filter['page'] = val
      this.filterHandle()
    },
    addHandle () {
      this.form = {
        id: '',
        name: '',
        send_type: String(this.$store.state.user.service_type_info['id']) === '2' ? 'template' : 'message',
        delay: 10,
        interval_time: 10,
        filter: {},
        send_content: [],
        begin_time: '',
        end_time: '',
        status: 1,
        remark: '',
        is_tk: '1'
      }
      this.count = 0
      this.dialogVisible = true
      this.getMpAutoPushCriteria()
    },
    async editHandle (row) {
      this.editVisible = true
      this.dialogLoading = true
      var showTk = false
      let form = JSON.parse(JSON.stringify(row))
      form.filter = []
      form.is_tk = String(form.is_tk)
      if (form.begin_time === '0000-00-00 00:00:00') {
        form.begin_time = ''
      }
      if (form.end_time === '0000-00-00 00:00:00') {
        form.end_time = ''
      }
      if (form.send_type === 'template') {
        form.send_content = JSON.parse(form.send_content)
        form.send_content.map(item => {
          if (item.url !== '') {
            showTk = true
          }
        })
      }
      let res = await Mp.Custom.decodeContent({id: form.id})
      if (!res['err_code']) {
        form.filter = res['data']['filter']
        if (form.send_type === 'message') {
          let content = []
          for (var i = 0; i < res['data']['content'].length; i++) {
            let item = res['data']['content'][i]['info'] || {
              invalid: true
            }
            item['type'] = res['data']['content'][i]['type']
            item['choose'] = true
            content.push(item)
          }
          form.send_content = content

          form.send_content.map(item => {
            if (item['type'] === 'local_text' || item['type'] === 'news') {
              showTk = true
            }
          })
        }
        this.details = JSON.parse(JSON.stringify(form))
        this.showTk = showTk
      }
      this.dialogLoading = false
    },
    deleteHandle (id, status) {
      this.$confirm('确定进行此操作吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.loading = true
        let res = await Mp.Custom.updateTaskStatus({
          id: id,
          status: status
        })
        if (!res.err_code) {
          // if (Number(status) === 1) {
          //   this.$message.success('关闭成功！')
          // } else if (Number(status) === 0) {
          //   this.$message.success('开启成功！')
          // } else {
          //   this.$message.success('删除成功！')
          // }
          this.$message.success('操作成功！')
          this.getTaskList()
        } else {
          this.$message.error(res.err_msg)
        }
        this.loading = false
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
    },
    handleExit () {
      this.showTk = false
      this.details = {}
      this.dialogVisible = false
      this.editVisible = false
    },
    showColorFn (val) {
      this.colorKey = val
      this.colorShow = true
    },
    cancelFn () {
      this.colorShow = false
    },
    okFn () {
      this.contentColor[this.colorKey] = this.color.hex
      this.colorShow = false
    },
    handleSubmit () {
      this.$refs['formTable'].validate((valid) => {
        if (valid) {
          this.handleSubmitFn()
        } else {
          return false
        }
      })
    },
    async handleSubmitFn () {
      this.dialogLoading = true
      var newform = Object.assign({}, this.form)
      // newform['filter'] = JSON.stringify(newform.filter)
      // console.log(newform)
      if (newform.send_type === 'message') {
        var contentData = []
        for (var i = 0; i < this.form.send_content.length; i++) {
          var item = {}
          item['type'] = this.form.send_content[i].type
          if (this.form.send_content[i].type === 'text') {
            item['content'] = this.form.send_content[i].id
          } else if (this.form.send_content[i].type === 'miniprogrampage') {
            item['content'] = {
              title: this.form.send_content[i].content.title,
              appid: this.form.send_content[i].content.appid,
              pagepath: this.form.send_content[i].content.pagepath,
              thumb_media_id: this.form.send_content[i].content.thumb_media_id
            }
          } else {
            item['content'] = this.form.send_content[i].media_id || this.form.send_content[i].id || this.form.send_content[i][0].media_id
          }
          contentData.push(item)
        }
        newform['send_content'] = contentData
      }
      if (!this.showTk) {
        delete newform['is_tk']
      }
      let res = await Mp.Custom.saveAutoPushInfo(newform)
      if (!res.err_code) {
        this.$message.success('添加成功！')
        this.dialogVisible = false
        this.resetFilter()
        this.getTaskList()
      } else {
        this.$message.error(res.err_msg)
      }
      this.dialogLoading = false
    },
    addModel () {
      this.modelVisible = true
    },
    modelSubmit () {
      this.$refs['contentTable'].validate((valid) => {
        if (valid) {
          this.$refs['modelForm'].validate((valid) => {
            if (valid) {
              for (var key in this.content) {
                this.modelfrom.content[key] = {
                  value: this.content[key],
                  color: this.contentColor[key]
                }
                this.contentList.map(item => {
                  if (key === item.key) {
                    this.modelfrom.content[key]['title'] = item.title
                  }
                })
              }
              let templateName = ''
              this.temList.map(item => {
                if (item.template_id === this.modelfrom.template_id) {
                  templateName = item.title
                }
              })
              this.form.send_content.push({
                template_name: templateName,
                template_id: this.modelfrom.template_id,
                url: this.modelfrom.url,
                miniprogram: {
                  appid: this.modelfrom.appid,
                  pagepath: this.modelfrom.pagepath
                },
                data: this.modelfrom.content
              })
              this.modelExit()
            } else {
              return false
            }
          })
        } else {
          return false
        }
      })
    },
    deleteModel (index) {
      this.form.send_content.splice(index, 1)
    },
    modelExit () {
      this.modelReset()
      this.modelVisible = false
    },
    modelReset () {
      this.modelfrom = {
        urlType: '0',
        template_id: '',
        content: {},
        url: '',
        appid: '',
        pagepath: ''
      }
      this.contentList = {}
      this.content = {}
      this.contentColor = {}
      this.contentRules = {}
    },
    addMaterial () {
      this.materialVisible = true
    },
    getValues (obj) {
      this.form.filter = JSON.stringify(obj)
    },
    async getTaskList () {
      this.loading = true
      let res = await Mp.Custom.getAutoPushTaskList(this.filter)
      this.tableData = res.data.list
      this.total = res.data.total
      this.loading = false
    },
    async getTemplateFields (id, cb) {
      this.content = {}
      this.contentList = []
      this.contentRules = {}
      this.contentColor = {}
      this.modelLoading = true
      let res = await Mp.TrackReply.getTemplateFields({
        template_id: id
      })
      if (!res.err_code) {
        res.data.map(item => {
          this.content[item.key] = ''
          this.contentRules[item.key] = []
          this.contentColor[item.key] = ''
          this.contentRules[item.key][0] = { required: true, message: '请填写完整', trigger: 'blur' }
        })
        this.content = Object.assign({}, this.content)
        this.contentList = res.data
        if (cb) {
          setTimeout(() => {
            cb()
          }, 200)
        }
      } else {
        this.$message.error(res.err_msg)
      }
      this.modelLoading = false
    },
    async init () {
      let resTemplate = await Mp.Template.getTemplateList()
      this.temList = resTemplate.data.list || []
    },
    async getMpAutoPushCriteria () {
      this.queryLoading = true
      let res = await Mp.Custom.getMpAutoPushCriteria()
      this.filters = res.data
      var options = []
      for (var key in res.data) {
        options.push({
          value: key,
          label: res.data[key].name
        })
      }
      this.filterOptions = options
      this.queryLoading = false
    }
  },
  created () {
    this.queryToFilter()
    this.init()
  }
};
</script>

<style scoped>
a {
  color: #409EFF;
}
.colorBox {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  text-align: center;
  z-index: 999999;
}
.colorSpan {
  display: block;
  width: 30px;
  height: 30px;
  float: right;
  background: #000;
}
.modelbox {
  width: 200px;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0 0 3px #ccc;
  padding: 10px;
  height: auto;
  overflow: hidden;
  float: left;
  margin: 0 20px 20px 0;
}
.modelcon ul {
  margin: 10px 0;
}
.modelcon ul li {
  font-size: 12px;
  line-height: 20px;
}
.modelcontrol {
  font-size: 14px;
  border-top: 1px solid #eee;
  padding-top: 5px;
}
.modelcontrol .fl {
  float: left;
}
.modelcontrol .fr {
  float: right;
}

.edit-filter-box ul {
  border: 1px solid #eee;
  padding: 10px;
  border-radius: 4px;
}
.edit-filter-box ul li p span:after {
  content: '，'
}
.edit-filter-box ul li p span:last-child:after {
  content: ''
}
.gx {
  line-height: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
  /*background: #ececec;*/
  /*text-align: center;*/
  /*color: #557895;*/
  text-indent: 10px;
  border: 1px dashed #eee;
  border-radius: 4px;
  background: #fcfcfc;
  text-align: center;
}
</style>
